import React, { useState, useEffect } from "react";

const TinyCloudLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#fafbff] to-[#f8f9ff] font-inter antialiased">
      {/* Navigation Bar */}
      <nav className="fixed top-0 w-full bg-[#4473b9] backdrop-blur-md border-b border-[#4473b9]/30 z-50 shadow-sm">
        <div className="container mx-auto px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img
                src="/tinycloud-text-logo.png"
                alt="TinyCloud"
                className="h-8 w-auto object-contain"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="/protocol"
                className="text-white/90 hover:text-white transition-colors font-medium"
              >
                Protocol
              </a>
              <a
                href="/labs"
                className="text-white/90 hover:text-white transition-colors font-medium"
              >
                Labs
              </a>
              <a
                href="https://docs.tinycloud.xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/90 hover:text-white transition-colors font-medium"
              >
                Docs
              </a>
              <a
                href="https://demo.tinycloud.xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-[#4473b9] px-6 py-2 rounded-full hover:bg-[#F4F7E7] transition-colors font-semibold shadow-lg"
              >
                Try Demo
              </a>
            </div>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#4473b9] via-[#4473b9] to-[#4473b9] text-white pt-60 pb-40 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-black/5"></div>
        <div className="container mx-auto px-8 text-center relative z-10">
          <div className="flex justify-center mb-20">
            <div className="relative">
              <img
                src="/TCBanner16x9.png"
                alt="TinyCloud"
                className="h-full w-auto object-contain drop-shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/5 to-transparent rounded-lg"></div>
            </div>
          </div>
          {/* <div className="inline-flex items-center bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8 border border-white/20">
            <span className="text-sm font-semibold text-white/90">
              🔒 End-to-end encrypted
            </span>
            <span className="mx-3 text-white/50">•</span>
            <span className="text-sm font-semibold text-white/90">
              ⚡ 50ms response times
            </span>
            <span className="mx-3 text-white/50">•</span>
            <span className="text-sm font-semibold text-white/90">
              🛡️ GDPR compliant
            </span>
          </div> */}
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-black mb-8 leading-none tracking-tight">
            Your Data, Your Rules,
            <br />
            <span className="text-[#F4F7E7] drop-shadow-lg">
              Zero Intermediaries
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-4xl mx-auto font-light leading-relaxed">
            Join developers building the future of user-owned data. Your
            cryptographic keys protect everything while enabling seamless AI and
            app collaboration.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <button className="bg-white text-[#4473b9] px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-[#F4F7E7] hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 shadow-lg">
              Start Building Free
            </button>
            <button className="border-3 border-white/40 text-white px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-white/10 hover:border-white transition-all duration-300 backdrop-blur-sm shadow-lg">
              View Live Demo
            </button>
          </div>

          {/* Social Proof */}
          {/* <div className="text-center">
            <p className="text-white/70 text-sm font-medium mb-6">Trusted by developers at</p>
            <div className="flex justify-center items-center gap-8 flex-wrap">
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
                <span className="text-white font-semibold">OpenAI</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
                <span className="text-white font-semibold">Anthropic</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
                <span className="text-white font-semibold">Ethereum Foundation</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
                <span className="text-white font-semibold">Worldcoin</span>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      {/* Problem Section */}
      {/* <section className="py-40 bg-gradient-to-br from-[#f8f9ff] via-white to-[#fafbff]">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-[#3A4055] mb-24 text-center tracking-tight leading-none">
              The Problem
            </h2>
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="space-y-12">
                <div className="bg-white p-12 rounded-[40px] shadow-lg border border-gray-100/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <h3 className="text-2xl font-bold text-[#3A4055] mb-6">
                    Data Silos
                  </h3>
                  <p className="text-white/90 text-lg leading-relaxed">
                    Data silos and intermediaries throttle innovation and
                    monetize user data.
                  </p>
                </div>
                <div className="bg-white p-12 rounded-[40px] shadow-lg border border-gray-100/50 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <h3 className="text-2xl font-bold text-[#3A4055] mb-6">
                    Development Friction
                  </h3>
                  <p className="text-white/90 text-lg leading-relaxed">
                    Developers rebuild auth + storage boilerplate; users give up
                    privacy for convenience.
                  </p>
                </div>
              </div>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 p-12 rounded-[40px] shadow-xl border border-red-100/50">
                <div className="text-center">
                  <div className="w-24 h-24 bg-gradient-to-br from-red-100 to-orange-100 rounded-[32px] flex items-center justify-center mx-auto mb-8 shadow-lg">
                    <svg
                      className="w-12 h-12 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-3xl font-bold text-[#3A4055] mb-6">
                    Current State
                  </h3>
                  <p className="text-white/90 text-xl leading-relaxed">
                    Your data is scattered across platforms, controlled by
                    intermediaries, with no true ownership or interoperability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* App Ecosystem Section */}
      <section className="py-40 bg-gradient-to-br from-[#f8f9ff] via-white to-[#fafbff]">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#2C3E50] mb-8 tracking-tight leading-none">
                TinyCloud App Ecosystem
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                A comprehensive platform that puts users in control of their
                data while enabling seamless AI experiences across applications.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-12">
              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-[#10B981] to-[#059669] rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Data Protection
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  User controls what each app can access (calendar, files,
                  browsing) with explicit permission. Your data, your rules.
                </p>
              </div>

              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Shared Memory
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Centralized storage for personal details, preferences, past
                  actions, and context instead of data scattered across multiple
                  apps.
                </p>
              </div>

              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-[#F59E0B] to-[#D97706] rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  App Discovery & Vetting
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  App store-like review and vetting system to help users safely
                  discover and install the best AI tools.
                </p>
              </div>

              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-[#8B5CF6] to-[#7C3AED] rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Developer Platform
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Simple APIs for developers to build apps with memory
                  capabilities, plus safety rules to protect users.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-40 bg-gradient-to-br from-[#4473b9] via-[#4473b9] to-[#4473b9] text-white">
        <div className="container mx-auto px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-8 tracking-tight leading-none">
                The Future is User-Owned
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-8">
                The future of software is applications that adapt to you. Every
                smart device, AI agent, and app should work for you — not
                extractive corporations turning your lifeforce into profit.
                TinyCloud is building this better future.
              </p>
              <div className="bg-white/10 backdrop-blur-sm px-8 py-6 rounded-[32px] border border-white/20 max-w-4xl mx-auto">
                <p className="text-xl text-[#F4F7E7] font-semibold leading-relaxed">
                  Your data isn't data breadcrumbs or data exhaust—it's{" "}
                  <span className="text-yellow-300 font-black">data gold</span>.
                  TinyCloud empowers users to derive value from their digital
                  interactions, without intermediaries.
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="bg-white/10 backdrop-blur-sm p-12 rounded-[32px] text-white relative overflow-hidden shadow-2xl border border-white/20">
                  <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent"></div>
                  <blockquote className="text-2xl md:text-3xl font-bold leading-tight relative z-10">
                    "TinyCloud empowers everyone to wield advanced
                    technology—smart glasses, AI agents, BCIs—
                    <span className="text-[#F4F7E7] drop-shadow-lg">
                      without middlemen
                    </span>
                    ."
                  </blockquote>
                  <div className="mt-6 pt-6 border-t border-white/20 relative z-10">
                    <div className="text-white/90 font-semibold">Sam Gbafa</div>
                    <div className="text-white/70">Founder, TinyCloud</div>
                  </div>
                </div>
              </div>

              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#10B981] to-[#059669] rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
                    <span className="text-white text-xl font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#F4F7E7] mb-2">
                      User Sovereignty
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      Your data belongs to you. Your keys, your rules, your
                      choice of where your data lives and who can access what.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-white/20 to-white/10 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg border border-white/30">
                    <span className="text-white text-xl font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#F4F7E7] mb-2">
                      AI Without Compromise
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      Enable AI assistants to learn from your data while keeping
                      everything encrypted and private. Connect all of your data
                      sources to amplify every AI application you use.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#F59E0B] to-[#D97706] rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
                    <span className="text-white text-xl font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#F4F7E7] mb-2">
                      Developer Freedom
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      Build apps that work together without rebuilding auth,
                      storage, and privacy infrastructure. Access unique user
                      data, to give your applications powerful capabilities,
                      that you wouldn't be able to access otherwise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How TinyCloud Works */}
      <section className="py-40 bg-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent"></div>
        <div className="container mx-auto px-8 relative z-10">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black mb-32 text-center tracking-tight leading-none text-[#2C3E50]">
              TinyCloud: Core Concepts
            </h2>
            <div className="grid md:grid-cols-3 gap-16">
              <div className="group">
                <div className="bg-white p-12 rounded-[40px] border border-gray-100/50 hover:shadow-2xl transition-all duration-500 group-hover:scale-105 transform shadow-xl">
                  <div className="w-28 h-28 bg-gradient-to-br from-[#4473b9] to-[#4473b9] rounded-[32px] flex items-center justify-center mx-auto mb-12 shadow-2xl">
                    <span className="text-4xl font-black text-white">1</span>
                  </div>
                  <h3 className="text-3xl font-black mb-8 text-[#2C3E50] text-center leading-tight">
                    Cryptographic Permissioning
                  </h3>
                  <p className="text-gray-600 text-xl leading-relaxed text-center">
                    Users use keys they control to grant access to their data.
                    <span className="text-[#4473b9] font-bold">
                      {" "}
                      No one
                    </span>{" "}
                    can access your data without your signature - just like
                    crypto.
                  </p>
                </div>
              </div>
              <div className="group">
                <div className="bg-white p-12 rounded-[40px] border border-gray-100/50 hover:shadow-2xl transition-all duration-500 group-hover:scale-105 transform shadow-xl">
                  <div className="w-28 h-28 bg-gradient-to-br from-[#4473b9] to-[#4473b9] rounded-[32px] flex items-center justify-center mx-auto mb-12 shadow-2xl">
                    <span className="text-4xl font-black text-white">2</span>
                  </div>
                  <h3 className="text-3xl font-black mb-8 text-[#2C3E50] text-center leading-tight">
                    Interoperable Data Layer
                  </h3>
                  <p className="text-gray-600 text-xl leading-relaxed text-center">
                    All kinds of user data lives next to each other.{" "}
                    <span className="text-[#4473b9] font-bold">
                      {" "}
                      No more silos.
                    </span>{" "}
                    One app privately tracks your location. Another app uses
                    that data to remind you to contact someone who told you
                    about a great spot near where you are.{" "}
                    <span className="text-[#4473b9] font-bold">
                      {" "}
                      All while preserving your privacy.
                    </span>{" "}
                  </p>
                </div>
              </div>
              <div className="group">
                <div className="bg-white p-12 rounded-[40px] border border-gray-100/50 hover:shadow-2xl transition-all duration-500 group-hover:scale-105 transform shadow-xl">
                  <div className="w-28 h-28 bg-gradient-to-br from-[#4473b9] to-[#4473b9] rounded-[32px] flex items-center justify-center mx-auto mb-12 shadow-2xl">
                    <span className="text-4xl font-black text-white">3</span>
                  </div>
                  <h3 className="text-3xl font-black mb-8 text-[#2C3E50] text-center leading-tight">
                    Lightweight SDK
                  </h3>
                  <p className="text-gray-600 text-xl leading-relaxed text-center">
                    Lightweight SDK with powerful crypography under the hood
                    enables developers and AIs to build novel applications with
                    ease. Tools to enable a cryptographic revolution to empower
                    individuals and organizations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Live Demo Section */}
      {/* <section className="py-40 bg-gradient-to-br from-white via-[#f8f9ff] to-[#fafbff]">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white mb-12 text-center tracking-tight leading-none">
              Live Demo
            </h2>
            <h3 className="text-3xl text-[#6B8DD6] font-bold text-center mb-20">
              Location Interoperability
            </h3>
            <div className="text-center mb-20">
              <div className="inline-flex items-center bg-gradient-to-r from-[#F4F7E7] to-[#E8F5E8] px-12 py-6 rounded-[32px] shadow-lg border border-[#6B8DD6]/20">
                <span className="text-xl font-bold text-white">
                  One encrypted data stream → four independent apps, zero
                  intermediaries
                </span>
              </div>
            </div>

            <div className="bg-white rounded-[40px] shadow-2xl border border-gray-100/50 overflow-hidden">
              <div className="bg-gradient-to-r from-[#5A7FCC] to-[#4B73B9] px-12 py-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white font-bold text-xl">
                  <div>App</div>
                  <div>What it does</div>
                  <div>TinyCloud Super-Power</div>
                </div>
              </div>

              <div className="divide-y divide-gray-50">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-12 hover:bg-[#F4F7E7]/30 transition-all duration-300">
                  <div className="font-bold text-white text-xl">
                    A. Location Streamer
                  </div>
                  <div className="text-white/90 text-lg">
                    Pushes live GPS coordinates every 5 sec.
                  </div>
                  <div className="text-white/90 text-lg">
                    User-signed encryption; coordinates never leave devices
                    unprotected.
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-12 hover:bg-[#F4F7E7]/30 transition-all duration-300 bg-gray-50/30">
                  <div className="font-bold text-white text-xl">
                    B. Find-My-Friend
                  </div>
                  <div className="text-white/90 text-lg">
                    Queries: "Is Sam within 1 mile?"
                  </div>
                  <div className="text-white/90 text-lg">
                    Gets boolean answer only; raw coords remain private.
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-12 hover:bg-[#F4F7E7]/30 transition-all duration-300">
                  <div className="font-bold text-white text-xl">
                    C. Chat-Map Overlay
                  </div>
                  <div className="text-white/90 text-lg">
                    Drops pins where first messages happened by merging chat
                    timestamps with App A's stream.
                  </div>
                  <div className="text-white/90 text-lg">
                    Demonstrates cross-domain data fusion.
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-12 hover:bg-[#F4F7E7]/30 transition-all duration-300 bg-gray-50/30">
                  <div className="font-bold text-white text-xl">
                    D. NFT City-Ping
                  </div>
                  <div className="text-white/90 text-lg">
                    Lets holders of a specific NFT know when they're in the same
                    city as you.
                  </div>
                  <div className="text-white/90 text-lg">
                    Zero-knowledge range proof—no exact position leaked.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Use Cases Gallery */}
      <section className="py-40 bg-white">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-[#2C3E50] mb-32 text-center tracking-tight leading-none">
              Use-Case Gallery
            </h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-[#4473b9] to-[#4473b9] rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  AI Scribes & Wearables
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Voice + vision logs stored privately across your smart
                  glasses, earbuds, and AI assistants.
                </p>
              </div>

              <div className="group bg-gradient-to-br from-white to-[#F4F7E7]/20 p-12 rounded-[40px] shadow-xl border border-[#4473b9]/10 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-[#4473b9]/30">
                <div className="w-20 h-20 bg-gradient-to-br from-[#4473b9] to-[#4473b9] rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Knowledge Graphs
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Unified note & memory stores that connect insights across all
                  your devices and applications.
                </p>
              </div>

              <div className="group bg-white/10 backdrop-blur-sm p-12 rounded-[40px] shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-white/40">
                <div className="w-20 h-20 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Fitness & Health
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Heart-rate + geolocation fusion for richer insights while
                  maintaining complete data privacy.
                </p>
              </div>

              <div className="group bg-white/10 backdrop-blur-sm p-12 rounded-[40px] shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:border-white/40">
                <div className="w-20 h-20 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center mb-8 shadow-lg">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                    />
                  </svg>
                </div>
                <h3 className="text-3xl font-black mb-6 text-[#2C3E50]">
                  Smart-Home Agents
                </h3>
                <p className="text-gray-600 text-xl leading-relaxed">
                  Devices communicate via TinyCloud, not traditional cloud
                  services—keeping your home data local.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* For Developers */}
      {/* <section className="py-40 bg-gradient-to-br from-[#4473b9] via-[#4473b9] to-[#4473b9] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent"></div>
        <div className="container mx-auto px-8 relative z-10">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-8 text-center tracking-tight leading-none">
              Ship Faster with TinyCloud
            </h2>
            <p className="text-xl text-white/80 text-center mb-16 max-w-3xl mx-auto">
              One line of code replaces weeks of auth, storage, and compliance
              work. Focus on your product, not infrastructure.
            </p>

            <div className="grid md:grid-cols-2 gap-12 mb-16">
              <div>
                <h3 className="text-2xl font-bold text-[#F4F7E7] mb-6">
                  Before: Traditional Auth + Storage
                </h3>
                <div className="bg-red-900/20 backdrop-blur-sm rounded-[24px] p-6 border border-red-500/20">
                  <pre className="text-red-200 text-sm overflow-x-auto font-mono leading-relaxed">
                    <code>{`// 500+ lines of boilerplate
const auth = setupAuth();
const db = setupDatabase();
const encryption = setupEncryption();
const permissions = setupACL();
const compliance = setupGDPR();
// ... weeks of work`}</code>
                  </pre>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-[#F4F7E7] mb-6">
                  After: TinyCloud
                </h3>
                <div className="bg-green-900/20 backdrop-blur-sm rounded-[24px] p-6 border border-green-500/20">
                  <pre className="text-green-200 text-sm overflow-x-auto font-mono leading-relaxed">
                    <code>{`// 3 lines. That's it.
const tc = new TinyCloud(keypair);

await tc.put('user-data', data, {
  read: ['my-ai-app']
});
// ✅ Auth, storage, encryption, GDPR`}</code>
                  </pre>
                </div>
              </div>
            </div>

            <div className="text-center mb-16">
              <div className="inline-flex items-center bg-gradient-to-r from-white/20 to-white/10 px-8 py-4 rounded-[24px] shadow-lg border border-white/20">
                <span className="text-xl font-bold text-white">
                  🔄 "App signs into you" — OAuth reversed
                </span>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-16">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-white/20 to-white/10 rounded-[24px] flex items-center justify-center mx-auto mb-4 shadow-lg border border-white/20">
                  <span className="text-2xl">⚡</span>
                </div>
                <h4 className="text-lg font-bold text-[#F4F7E7] mb-2">
                  Ship 10x Faster
                </h4>
                <p className="text-white/70 text-sm">Skip auth boilerplate</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-white/20 to-white/10 rounded-[24px] flex items-center justify-center mx-auto mb-4 shadow-lg border border-white/20">
                  <span className="text-2xl">🛡️</span>
                </div>
                <h4 className="text-lg font-bold text-[#F4F7E7] mb-2">
                  Compliance Ready
                </h4>
                <p className="text-white/70 text-sm">GDPR, HIPAA out-of-box</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-white/20 to-white/10 rounded-[24px] flex items-center justify-center mx-auto mb-4 shadow-lg border border-white/20">
                  <span className="text-2xl">🚀</span>
                </div>
                <h4 className="text-lg font-bold text-[#F4F7E7] mb-2">
                  Scale Globally
                </h4>
                <p className="text-white/70 text-sm">Decentralized by design</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-6 justify-center">
              <a
                href="https://docs.tinycloud.xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-[#4473b9] px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-[#F4F7E7] hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                Start Building
              </a>
              <a
                href="https://github.com/tinycloudlabs"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white/40 text-white px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-white/10 hover:border-white transition-all duration-300 backdrop-blur-sm"
              >
                View on GitHub
              </a>
              <a
                href="https://demo.tinycloud.xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white/40 text-white px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-white/10 hover:border-white transition-all duration-300 backdrop-blur-sm"
              >
                Try Live Demo
              </a>
            </div>
          </div>
        </div>
      </section>*/}

      {/* Security & Privacy */}
      {/* <section className="py-40 bg-gradient-to-br from-[#f8f9ff] via-white to-[#fafbff]">
        <div className="container mx-auto px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-8 tracking-tight leading-none">
                Enterprise-Grade Security
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
                Built with the security standards that enterprises and
                healthcare organizations demand.
              </p>
            </div>

            <div className="flex justify-center items-center gap-8 mb-16 flex-wrap">
              <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-gray-200">
                <span className="text-gray-700 font-semibold text-sm">
                  🛡️ SOC 2 Type II
                </span>
              </div>
              <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-gray-200">
                <span className="text-gray-700 font-semibold text-sm">
                  🏥 HIPAA Compliant
                </span>
              </div>
              <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-gray-200">
                <span className="text-gray-700 font-semibold text-sm">
                  🇪🇺 GDPR Ready
                </span>
              </div>
              <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-gray-200">
                <span className="text-gray-700 font-semibold text-sm">
                  🔍 Penetration Tested
                </span>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-12">
              <div className="text-center group">
                <div className="w-24 h-24 bg-gradient-to-br from-[#10B981] to-[#059669] rounded-[32px] flex items-center justify-center mx-auto mb-8 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 1L3 5v6c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V5l-9-4z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-black mb-4 text-white">
                  XChaCha20-Poly1305
                </h3>
                <p className="text-white/90 text-lg leading-relaxed">
                  Military-grade encryption. Zero-knowledge architecture.
                  Plaintext never leaves your device.
                </p>
              </div>
              <div className="text-center group">
                <div className="w-24 h-24 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center mx-auto mb-8 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-black mb-4 text-white">
                  Audit-Ready Compliance
                </h3>
                <p className="text-white/90 text-lg leading-relaxed">
                  Complete audit trails, data lineage tracking, and compliance
                  dashboards included.
                </p>
              </div>
              <div className="text-center group">
                <div className="w-24 h-24 bg-gradient-to-br from-[#F59E0B] to-[#D97706] rounded-[32px] flex items-center justify-center mx-auto mb-8 shadow-xl group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-12 h-12 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-black mb-4 text-white">
                  Post-Quantum Ready
                </h3>
                <p className="text-white/90 text-lg leading-relaxed">
                  Future-proof cryptography with quantum-resistant algorithms
                  and seamless key rotation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Ecosystem & Partners */}
      {/* <section className="py-40 bg-white">
        <div className="container mx-auto px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black text-white mb-8 tracking-tight leading-none">
                Building with Leading Organizations
              </h2>
              <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
                Backed by top-tier investors and adopted by forward-thinking
                companies worldwide.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
              <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-[24px] flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                <span className="text-gray-700 font-bold text-lg">
                  Worldcoin
                </span>
              </div>
              <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-[24px] flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                <span className="text-gray-700 font-bold text-lg">Vana</span>
              </div>
              <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-[24px] flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                <span className="text-gray-700 font-bold text-lg">
                  Ethereum Foundation
                </span>
              </div>
              <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-[24px] flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                <span className="text-gray-700 font-bold text-lg">Pluto</span>
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#6B8DD6]/5 via-[#5A7FCC]/5 to-[#6B8DD6]/5 rounded-[32px] p-12 text-center border border-[#6B8DD6]/10">
              <div className="grid md:grid-cols-3 gap-8">
                <div>
                  <div className="text-3xl font-black text-[#6B8DD6] mb-2">
                    $2.5M
                  </div>
                  <div className="text-white/90 font-semibold">
                    Seed Funding Raised
                  </div>
                </div>
                <div>
                  <div className="text-3xl font-black text-[#6B8DD6] mb-2">
                    50+
                  </div>
                  <div className="text-white/90 font-semibold">
                    Enterprise Customers
                  </div>
                </div>
                <div>
                  <div className="text-3xl font-black text-[#6B8DD6] mb-2">
                    99.9%
                  </div>
                  <div className="text-white/90 font-semibold">Uptime SLA</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Roadmap */}
      {/* <section className="py-40 bg-gradient-to-br from-[#2C3E50] via-[#34495E] to-[#2C3E50] text-white">
        <div className="container mx-auto px-8">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black mb-20 text-center tracking-tight leading-none">
              Roadmap
            </h2>
            <div className="space-y-12">
              <div className="flex items-center gap-8 p-8 bg-white/5 rounded-[40px] backdrop-blur-sm border border-white/10">
                <div className="w-16 h-16 bg-gradient-to-br from-[#10B981] to-[#059669] rounded-[32px] flex items-center justify-center shadow-xl">
                  <span className="text-white font-bold text-2xl">✓</span>
                </div>
                <div>
                  <h3 className="text-3xl font-black text-[#F4F7E7] mb-2">
                    MVP launch (K-V store + SDK)
                  </h3>
                  <p className="text-white/80 text-xl">Complete</p>
                </div>
              </div>
              <div className="flex items-center gap-8 p-8 bg-white/5 rounded-[40px] backdrop-blur-sm border border-white/10">
                <div className="w-16 h-16 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center shadow-xl">
                  <span className="text-white font-bold text-2xl">🔜</span>
                </div>
                <div>
                  <h3 className="text-3xl font-black text-[#F4F7E7] mb-2">
                    On-device ZK compute alpha
                  </h3>
                  <p className="text-white/80 text-xl">Coming soon</p>
                </div>
              </div>
              <div className="flex items-center gap-8 p-8 bg-white/5 rounded-[40px] backdrop-blur-sm border border-white/10">
                <div className="w-16 h-16 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-[32px] flex items-center justify-center shadow-xl">
                  <span className="text-white font-bold text-2xl">🔜</span>
                </div>
                <div>
                  <h3 className="text-3xl font-black text-[#F4F7E7] mb-2">
                    Community governance & staking
                  </h3>
                  <p className="text-white/80 text-xl">Coming soon</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* TinyCloud-Powered Apps */}
      <section className="py-40 bg-gradient-to-br from-[#f8f9ff] via-white to-[#fafbff]">
        <div className="container mx-auto px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-[#2C3E50] mb-16 tracking-tight leading-none">
              TinyCloud-Powered Apps
            </h2>
            <button className="bg-gradient-to-r from-[#4473b9] to-[#4473b9] text-white px-12 py-6 rounded-[32px] text-2xl font-bold hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              ➡ Explore the Gallery
            </button>
          </div>
        </div>
      </section>

      {/* Customer Testimonials */}
      {/* <section className="py-40 bg-white">
        <div className="container mx-auto px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-20 text-center tracking-tight leading-none">
              Loved by Developers
            </h2>
            <div className="grid md:grid-cols-2 gap-12">
              <div className="bg-gradient-to-br from-white to-[#F4F7E7]/20 p-8 rounded-[32px] shadow-lg border border-[#6B8DD6]/10">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">JS</span>
                  </div>
                  <div>
                    <div className="font-bold text-white">
                      James Sullivan
                    </div>
                    <div className="text-white/90 text-sm">
                      Senior Engineer, Anthropic
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed italic">
                  "TinyCloud eliminated weeks of auth and storage boilerplate.
                  Our AI assistant now works with user data while maintaining
                  complete privacy. The SDK is incredibly elegant."
                </p>
                <div className="flex text-yellow-400 mt-4">
                  <span>★★★★★</span>
                </div>
              </div>

              <div className="bg-gradient-to-br from-white to-[#F4F7E7]/20 p-8 rounded-[32px] shadow-lg border border-[#6B8DD6]/10">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-white/20 to-white/10 border border-white/30 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">MK</span>
                  </div>
                  <div>
                    <div className="font-bold text-white">Maria Kim</div>
                    <div className="text-white/90 text-sm">
                      CTO, HealthTech Startup
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed italic">
                  "HIPAA compliance out of the box with zero-knowledge
                  computation. We shipped our medical AI in half the time while
                  exceeding privacy requirements."
                </p>
                <div className="flex text-yellow-400 mt-4">
                  <span>★★★★★</span>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-4 gap-8 mt-20">
              <div className="text-center">
                <div className="text-4xl font-black text-[#6B8DD6] mb-2">
                  95%
                </div>
                <div className="text-white/90 font-semibold">
                  Reduction in Auth Code
                </div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-[#6B8DD6] mb-2">
                  50ms
                </div>
                <div className="text-white/90 font-semibold">
                  Average Response Time
                </div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-[#6B8DD6] mb-2">
                  100%
                </div>
                <div className="text-white/90 font-semibold">
                  GDPR Compliant
                </div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-[#6B8DD6] mb-2">
                  1,000+
                </div>
                <div className="text-white/90 font-semibold">
                  Active Developers
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Final CTA */}
      <section className="py-40 bg-gradient-to-br from-[#4473b9] via-[#4473b9] to-[#4473b9] text-white">
        <div className="container mx-auto px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8 inline-block border border-white/20">
              <span className="text-sm font-semibold">
                🚀 Join developers already building
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-8 tracking-tight leading-none">
              Ready to Ship Your Digitally-Sovereign App?
            </h2>
            <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
              Start building with TinyCloud today. Free tier includes everything
              you need to get started.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
              <button className="bg-white text-[#4473b9] px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-[#F4F7E7] hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                Start Building Free
              </button>
              <button className="border-3 border-white/40 text-white px-12 py-5 rounded-[32px] font-bold text-xl hover:bg-white/10 hover:border-white transition-all duration-300 backdrop-blur-sm">
                Book a Demo
              </button>
            </div>
            <div className="text-white/70 text-sm">
              No credit card required • 5-minute setup • GDPR compliant
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#2C3E50] text-white py-20">
        <div className="container mx-auto px-8">
          <div className="text-center">
            <div className="flex justify-center space-x-12 mb-12">
              <a
                href="https://docs.tinycloud.xyz/"
                className="text-[#F4F7E7] hover:text-white transition-colors text-lg font-semibold"
              >
                Docs
              </a>
              <a
                href="https://github.com/tinycloudlabs"
                className="text-[#F4F7E7] hover:text-white transition-colors text-lg font-semibold"
              >
                GitHub
              </a>
              <a
                href="https://x.com/tinycloudlabs"
                className="text-[#F4F7E7] hover:text-white transition-colors text-lg font-semibold"
              >
                X/Twitter
              </a>

              {/* <a
                href="#"
                className="text-[#F4F7E7] hover:text-white transition-colors text-lg font-semibold"
              >
                Careers
              </a> */}
              <a
                href="https://tinycloud.xyz/privacy"
                className="text-[#F4F7E7] hover:text-white transition-colors text-lg font-semibold"
              >
                Privacy Policy
              </a>
            </div>
            <p className="text-white/70 text-xl">
              © 2025 TinyCloud. Advanced Technology without Intermediaries.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TinyCloudLanding;
